.pcFooter {
  display: none;
  padding-top: 24px;
  padding-bottom: 10px;
  background: #f9f9f9;

  @media screen and (width >= 1180px) {
    padding-top: 64px;
  }

  @media screen and (width >= 768px) {
    display: block;
  }
}

.footerContent {
  margin-inline: auto;

  @media screen and (width >= 768px) {
    width: 736px;
  }

  @media screen and (width >= 915px) {
    width: 883px;
  }

  @media screen and (width >= 1180px) {
    width: 1120px;
  }
}

.listsWrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-bottom: 32px;
}

.title {
  margin-bottom: 12px;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
}

.list {
  display: grid;
  grid-template-rows: repeat(6, auto);
  grid-auto-flow: column;
  gap: 12px;
}

.listLink {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  cursor: pointer;

  &:hover {
    color: var(--color-text-primary);
    text-decoration: underline;
  }
}

.section {
  width: 195px;
}

.recommendedServiceSection {
  width: 502px;

  @media screen and (width >= 1180px) {
    width: 580px;
  }
}

.snsSection {
  width: 281px;
}

.footerFooter {
  padding-block: 16px;
  margin-top: 16px;
  border-top: 1px solid var(--color-border-normal);

  @media screen and (width >= 1180px) {
    margin-top: 100px;
  }
}

.footerList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  justify-content: center;
  width: 600px;
  margin-inline: auto;

  @media screen and (width >= 1180px) {
    justify-content: start;
    width: unset;
  }
}

.copyright {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  text-align: center;

  @media screen and (width >= 1180px) {
    text-align: left;
  }
}
